export interface AssignCLAManagerDesigneeInput {
  companyId: string;
  projectId: string;
  userEmail: string;
}
